import React from "react";
import InternalLink from "../../components/InternalLink";

function DocsSidebar({ isOpen, onClose, sections }) {
    return (
        <>
            {/* Mobile overlay */}
            <div
                className={`fixed inset-0 bg-black/50 z-30 lg:hidden transition-opacity duration-300 ${
                    isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
                onClick={onClose}
            />

            {/* Sidebar */}
            <div
                className={`fixed lg:sticky top-0 inset-y-0 left-0 z-40 w-64 transform transition-transform duration-300 ease-in-out ${
                    isOpen
                        ? "translate-x-0"
                        : "-translate-x-full lg:translate-x-0"
                } h-[100dvh] lg:h-screen overflow-hidden bg-white  border-r border-gray-200  lg:py-0 py-20`}
            >
                {/* <div className="sticky top-0 bg-white  p-4 border-b border-gray-200 ">
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="w-full pl-3 pr-10 py-2 border rounded-lg text-sm focus:outline-none focus:border-blue-500   "
                        />
                        <span className="absolute right-3 top-2.5 text-gray-400">
                            ⌘K
                        </span>
                    </div>
                </div> */}

                <div className="overflow-y-auto h-[calc(100vh-5rem)]">
                    <div className="p-4">
                        {sections.map((section, index) => (
                            <div key={index} className="mb-6">
                                <h3 className="text-sm font-medium text-gray-500  mb-2">
                                    {section.title}
                                </h3>
                                <ul className="space-y-1">
                                    {section.items.map((item, itemIndex) => (
                                        <li key={itemIndex}>
                                            <InternalLink
                                                to={item.path}
                                                onClick={onClose}
                                                className="block px-2 py-1 text-sm text-gray-600  hover:text-blue-600 dark:hover:text-blue-400 rounded-md hover:bg-gray-50 "
                                            >
                                                {item.title}
                                            </InternalLink>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default DocsSidebar;
